var portfolioHeader = {
	baseCurrency: "Valuta di base",
	numberOfPositions: "Posizioni",
	portfolioValue: "Valore del portafoglio in {currency}",
	todayChange: "Variazione oggi",
	unrealizedPerformance: "Perf. non realizzata",
	purchaseValue: "Valore di acquisto",
	realizedProfits: "Utili realizzati",
	totalValue: "Totale valore",
	totalPerformance: "Totale perf.",
	lastCalculationDateTime: "Ultimo calc."
};
var it = {
	portfolioHeader: portfolioHeader
};

export { it as default, portfolioHeader };
